<script lang="ts">
	export let value = '';
	export let placeholder = '';
	export let cols = 50;
	export let rows = 4;
	export let disabled = false;
	export let readonly = false;
	export let name: string;
	export let label = '';
	export let required = false;
	export let maxLength: number | undefined = undefined;
	export let fullWidth = false;
</script>

<div class:fullWidth>
	{#if label}
		<label for={name}>{label}</label>
	{/if}
	<textarea
		bind:value
		{disabled}
		{name}
		{cols}
		{rows}
		{placeholder}
		{readonly}
		{required}
		maxlength={maxLength}
		on:change
		on:input
		on:keydown
		on:keyup
		on:focus
		on:blur
		on:paste />
</div>

<style>
	textarea {
		inline-size: 100%;
		padding: var(--gutterSmall);
		border: 1px solid rgb(204 204 204);
		border-radius: 4px;
		outline: none;
		resize: none;
	}

	textarea:focus {
		border: 1px solid var(--blueDark);
	}

	textarea:read-only {
		cursor: default;
	}

	.fullWidth {
		inline-size: 100%;
	}
</style>
